import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/global.css'
import './assets/styles/admin-dashboard.css'
import './assets/styles/sidebar.css'
import './assets/styles/faculty-dashboard.css'
import './assets/styles/faculty-research.css'

createApp(App).use(router).mount('#app')
